import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/HeroSection.css";

const IMAGES = [
  "/images/hero1.jpg",
  "/images/hero2.jpg",
  "/images/hero3.jpg",
  "/images/hero4.jpg",
  "/images/hero5.jpg",
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  // autoplay slideshow
  useEffect(() => {
    if (!IMAGES.length) return;
    const id = setInterval(() => {
      setCurrent((p) => (p + 1) % IMAGES.length);
    }, 4000); // 4 seconds
    return () => clearInterval(id);
  }, []);

  return (
    <section className="hero" id="hero">
      {/* background slideshow */}
      <div className="hero-bg">
        <AnimatePresence mode="wait">
          <motion.div
            key={current}
            className="hero-slide"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            style={{ backgroundImage: `url(${IMAGES[current]})` }}
          />
        </AnimatePresence>
        <div className="hero-overlay" />
      </div>

      {/* content */}
      <div className="hero-content">
        <div className="hero-inner">
          <h1 className="hero-title">Who We Are</h1>

          <p className="hero-subtitle">
            Elevate <span className="hero-highlight">Your Projects with Precision</span> AVEVA E3D &amp; Hexagon SP3D.
          </p>

          <a href="#contact" className="hero-cta">Read More</a>
        </div>
      </div>
    </section>
  );
}
